import { atom, useAtomValue, useSetAtom } from 'jotai'
import { useCallback } from 'react'

const isOpen = atom(false)
const evaluationId = atom('')
const evaluationVersion = atom(-1)
const evaluationName = atom('')

export function useEditEvaluationModalValues() {
  return {
    isOpen: useAtomValue(isOpen),
    evaluationId: useAtomValue(evaluationId),
    evaluationVersion: useAtomValue(evaluationVersion),
    evaluationName: useAtomValue(evaluationName),
  }
}

export function useShowEditEvaluationNameModal() {
  const setIsOpen = useSetAtom(isOpen)
  const setEvaluationId = useSetAtom(evaluationId)
  const setEvaluationVersion = useSetAtom(evaluationVersion)
  const setEvaluationName = useSetAtom(evaluationName)

  return useCallback(
    ({
      evaluationId,
      evaluationVersion,
      evaluationName,
    }: {
      evaluationId: string
      evaluationVersion: number
      evaluationName: string
    }) => {
      setIsOpen(true)
      setEvaluationId(evaluationId)
      setEvaluationVersion(evaluationVersion)
      setEvaluationName(evaluationName)
    },
    []
  )
}

export function useCloseEditEvaluationNameModal() {
  const setIsOpen = useSetAtom(isOpen)
  const setEvaluationId = useSetAtom(evaluationId)
  const setEvaluationVersion = useSetAtom(evaluationVersion)
  const setEvaluationName = useSetAtom(evaluationName)

  return useCallback(() => {
    setIsOpen(false)
    setEvaluationId('')
    setEvaluationVersion(-1)
    setEvaluationName('')
  }, [])
}
